<template>
  <base-dropdown class="dropdown-min-select" :close-by-menu-click="true">
    <template #buttonText>
      <div class="d-flex justify-content-end mr-1">
        <img class="mr-1" width="20" :src="`/${lang}.svg`" alt="flag" />
        <span>{{ lang }}</span>
      </div>
    </template>
    <template #dropdownContent>
      <div
        v-for="(lang, id) in langList"
        :key="id"
        :data-value="id"
        class="dropdown-item"
        @click="setLocale(id)"
      >
        <div class="d-flex justify-content-end">
          <img class="mr-1" width="20" :src="`/${lang}.svg`" alt="flag" />
          <span>{{ lang }}</span>
        </div>
      </div>
    </template>
  </base-dropdown>
</template>

<script>
import '@/styles/components/languageSwitcher.less'

export default {
  name: 'LanguageSwitcher',
  components: {
    BaseDropdown: () => import('@/base/BaseDropdown.vue')
  },
  data() {
    return {
      isVisible: false,
      focusedIndex: 0,
      langList: {
        ru: 'ru',
        en: 'en'
      },
      localSelected: null
    }
  },
  created() {
    if (!localStorage.getItem('lang')) {
      localStorage.setItem('lang', this.$i18n.locale)
    }
    this.localSelected = localStorage.getItem('lang')
  },
  computed: {
    lang() {
      return this.localSelected
    }
  },
  methods: {
    setLocale(locale) {
      window.location.reload()
      this.$i18n.locale = locale
      this.localSelected = locale
      localStorage.setItem('lang', locale)
    }
  }
}
</script>
